import {
  getMe,
  getToken,
} from '@service/http/auth'

import { setDataToken } from '../service/http/auth/index'
import store from '../store'

export const HomeRoute = {
  path: '/home',
  name: 'home',
  beforeEnter: (to, from, next) => {
    const token = getToken()
    if (!token) {
      next({ name: 'landingPage' })
      return
    }

    getMe()
      .then(() => {
        let routeReturn = { name: 'login' }
        let currentUser = store.state.auth.currentUser
        if (currentUser && currentUser.id) {
          let defaultRoute = currentUser.getHomeRoute()
          if (defaultRoute) {
            routeReturn = defaultRoute
          }
        }
        next(routeReturn)
      })
      .catch((e) => {
        setDataToken()
        next({ name: 'login' })
      })
  },
}
